<template>
    <div id="project">
        <p>You have the opportunity to contribute to a specific project on tribal land.</p>
        <label for="projectSelect" class="select-wrap">
            <select name="projectSelect" id="projectSelect" v-model="formProject" @change="changed">
                <option value="" disabled selected hidden>Select Your Project</option>
                <option v-if="project.active" v-for="project in projectList" :value="project">{{project.name}}</option>
            </select>
        </label>
        <div id="projectDesc" v-if="this.formProject !== ''">
            <p>{{formProject.desc}}</p>
            <p v-if="this.formProject.total_donated > 0">Together, we have raised
                ${{formProject.total_donated.toFixed(2)}} for this project, leading to {{roundToDecimal(formProject.num_completed, 1)}}
                {{formProject.unit_name}}.</p>
            <p v-if="this.formProject.total_donated === 0">Be the first to donate to this project!</p>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import formatting from "../../mixins/formatting";

    export default {
        name: "ProjectSelect",
        mixins: [formatting],
        data() {
            return {
                projectList: {},
                formProject: ""
            };
        },
        async mounted() {
            this.formProject = this.$props.project;
            this.projectList = await axios.get(this.$store.getters["server"] + "/projects", {headers: {"Access-Control-Allow-Origin": this.$store.getters["server"]}})
                .then((data) => {
                    console.log(data.data.projects);
                    return data.data.projects;
                });
        },
        methods: {
            changed(e) {
                this.$emit("project-change", this.formProject);
            }
        },
        props: ["project"]
    };
</script>

<style scoped lang="less">
    @import (reference) "../../assets/variables";
    #project{
        margin: 1.5rem 0 2rem;
    }

    #projectSelect{
        border-bottom: 2px solid @lightest-gray;
    }
    #projectDesc{
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/form-elements/ProjectSelect.vue